/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseOralExamPracticeEnsureResponseData } from './genericApiResponseOralExamPracticeEnsureResponseData';
import type { GenericApiResponseOralExamPracticeEnsureResponseMessage } from './genericApiResponseOralExamPracticeEnsureResponseMessage';
import type { GenericApiResponseOralExamPracticeEnsureResponsePagination } from './genericApiResponseOralExamPracticeEnsureResponsePagination';
import type { GenericApiResponseOralExamPracticeEnsureResponseError } from './genericApiResponseOralExamPracticeEnsureResponseError';

export interface GenericApiResponseOralExamPracticeEnsureResponse {
  data?: GenericApiResponseOralExamPracticeEnsureResponseData;
  message?: GenericApiResponseOralExamPracticeEnsureResponseMessage;
  pagination?: GenericApiResponseOralExamPracticeEnsureResponsePagination;
  error?: GenericApiResponseOralExamPracticeEnsureResponseError;
  statusCode?: number;
}
